import _slicedToArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.entries.js";
// 导入自己需要的组件
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { ElNotification, ElMessageBox } from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
// import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
var element = {
  install: function install(app) {
    app.use(ElementPlus, {
      locale: zhCn,
      message: {
        max: 1
      },
      notification: {
        max: 1
      }
    });
    for (var _i = 0, _Object$entries = Object.entries(ElementPlusIconsVue); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        component = _Object$entries$_i[1];
      app.component(key, component);
    }

    // Register global methods
    app.config.globalProperties.$notify = ElNotification;
    app.config.globalProperties.$msgbox = ElMessageBox;
    app.config.globalProperties.$alert = ElMessageBox.alert;
    app.config.globalProperties.$confirm = ElMessageBox.confirm;
    app.config.globalProperties.$prompt = ElMessageBox.prompt;

    // Register loading directive
    // app.use(ElLoading.directive)
  }
};
export default element;